
export function replaceEmpty(text) {

    if (isStringEmpty(text)) {
        return "--";
    }
    else {
        return text;
    }
}

export function isStringEmpty(string) {

    return !string || string.trim().length == 0;
}

export function splitToMultiLine(string, needle) {

    let list = string.split(needle);
    var newstring = "";
    for (var i = 0; i < list.length; i++) {

        if (newstring.length != 0) {

            newstring += "\n";
        }

        newstring += list[i];
    }

    return newstring;
}

export function prefixZero(value, size) {

    if (String(value).length >= size) {

        return value;
    }

    const diff = size - String(value).length;
    var zeros = "";
    for (var i = 0; i < diff; i++) {

        zeros = String(zeros) + "0";
    }

    return String(zeros) + String(value);
}

export function getFileExtensionFromName(fileName) {

    return fileName.split('.').pop().toLowerCase();
}

export function urlEncode(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
    });
}

export function urlDecode(str) {
    return decodeURIComponent(str);
}
export function capitalizeText(str) {
    str = str.toLowerCase();
    return str.charAt(0).toUpperCase() + str.slice(1);
}
